module.exports = __webpack_public_path__ + "static/media/img_personal_bg.6e6dbaeb.svg";